//3rd Party Components
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const Container = ({ show, children }) => {

    const showContainer = (show, children) => {
        if (show) {
            return (
                <div id="container" className="body container">

                    {children}

                </div>
            )
        }
        else {
            return null;
        }
    }
    
    return (
        <Fragment>

            {showContainer(show, children)}

        </Fragment>
    )        
   
}

Container.propTypes = {
    show: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.object.isRequired, PropTypes.array.isRequired])
};

export default Container;
